import { twMerge } from 'tailwind-merge';
import TimeList from './TimeList';
import { classes } from './utils';

export type TimePickerProps = {
  showTitles?: boolean;
  className?: string;
  hours?: number;
  minutes?: number;
  hoursOptions: { label: string; value: number }[];
  minutesOptions: { label: string; value: number }[];
  onChange: (time: { hours?: number; minutes?: number }) => void;
};

export default function TimePicker({
  showTitles = true,
  hours,
  minutes,
  hoursOptions,
  minutesOptions,
  onChange,
  className,
}: TimePickerProps) {
  return (
    <div className={twMerge(classes.wrapper, className)}>
      <TimeList
        className={classes.hours}
        title={showTitles ? 'Hours' : undefined}
        value={hours}
        options={hoursOptions}
        onSelect={(hours) => onChange({ hours })}
      />
      <TimeList
        className={classes.minutes}
        title={showTitles ? 'Minutes' : undefined}
        value={minutes}
        options={minutesOptions}
        onSelect={(minutes) => onChange({ minutes })}
      />
    </div>
  );
}
